import type { SegmentedChipOption } from '@pcln/horizon'

export const AI_SEARCH_MODE = 'ai'
export const STANDARD_SEARCH_MODE = 'standard'

const standardSearchModeOption: SegmentedChipOption = {
  label: 'Standard Search',
  value: STANDARD_SEARCH_MODE,
  name: 'search-mode',
  iconLeft: 'manage_search',
  type: 'chip',
}

const aiSearchModeOption: SegmentedChipOption = {
  label: 'Describe Your Trip',
  value: AI_SEARCH_MODE,
  name: 'search-mode',
  customIcon: 'AiSearch',
  type: 'chip',
  badge: { children: 'Beta', palette: 'penny', emphasis: 'medium', size: 'sm' },
}

export const SEARCH_MODE_OPTIONS: SegmentedChipOption[] = [standardSearchModeOption, aiSearchModeOption]

export const AI_SEARCH_PLACEHOLDER = 'Try ‘Orlando resort for a family of 4 in late July under $2000’'

export const AI_SEARCH_ANIMATED_PLACEHOLDERS = [
  'Los Angeles with Free Parking',
  'Nashville with Free Breakfast',
  'Las Vegas with Swimming Pool',
  'Phoenix with Pets Allowed',
] as const

export const AI_SEARCH_HELPER_TEXT = 'Tell us about your stay. Include a location for the best results.'

/** Matches the age TravelerSelection applies when a child is added in AI search. */
export const AI_SEARCH_DEFAULT_CHILD_AGE = '10'

export const AI_SEARCH_CHILD_AGE_HELPER_TEXT =
  "Add your child's age at check-in for the best deals and assistance. Each hotel has unique policies."

export function aiSearchHelperText(children: number) {
  return children > 0 ? AI_SEARCH_CHILD_AGE_HELPER_TEXT : AI_SEARCH_HELPER_TEXT
}

export const AI_SEARCH_INPUT_LABEL = 'Describe Your Trip'

export const AI_SEARCH_EXAMPLES_LABEL = 'Some examples to get you started:'

export const AI_SEARCH_NO_RECOMMENDATIONS_LINK_LABEL = 'Standard Search'

export const AI_SEARCH_NO_RECOMMENDATIONS_AFTER_LINK = '.'

export const AI_SEARCH_RESOLVE_ERROR_BEFORE_LINK =
  "We couldn't find a match for that trip. AI Search is in beta, for full results switch to "

/** Minimum trimmed characters before `/nlsearch` fetch / filter chips appear. */
export const AI_SEARCH_MIN_QUERY_LENGTH = 2

export function hasAiSearchMinLength(value: string) {
  return value.trim().length >= AI_SEARCH_MIN_QUERY_LENGTH
}

// Hardcoded for now. These will eventually be driven by type-ahead responses.
export const AI_SEARCH_TRY_ASKING_CHIPS = [
  'Las Vegas with Pool',
  'Miami Deals',
  'New York with Free Breakfast',
  'Chicago 4 Star+',
] as const
